<template>
  <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
    <div class="d-flex">
      <div class="px-4 ml-auto">لینک پرداخت شخصی</div>
      <div class="px-4">
      </div>
    </div>
    <hr>
    <div class="text-center">
      <div class="my-3 py-3">
        <div class="my-3">
          <div v-show="width < 480" id="qr_for_small_width"></div>
          <div v-show="width >= 480" id="big_qr"></div>
        </div>
        <div class="border rounded-pill mx-auto p-2" style="width: fit-content;">
          <b class="en_num p-2" style="letter-spacing: 2px;" v-text="ps_link_text"></b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrCodeWithLogo from "qr-code-with-logo";
import {mapGetters} from "vuex";

export default {
  data()
  {
    return {
      width: window.innerWidth,
    }
  },
  created() {
    window.addEventListener("resize", this.myResizeEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myResizeEventHandler);
  },
  methods:
  {
    myResizeEventHandler(event) {
      this.width = window.innerWidth;
    },
    createQrCode() {
      setTimeout(() => {
        let width = this.width;
        let qr_size = width * 0.6;

        if (qr_size > 480 || width < 480) {
            qr_size = 480;
        }

        let qr_canvas = document.createElement('img');

        document.getElementById('big_qr').appendChild(qr_canvas);

        QrCodeWithLogo.toImage({
          image: qr_canvas,
          content: this.ps_link,
          width: qr_size,
          height: qr_size,
          logo: {
            src: "./favicon_new_dark.png",
            borderRadius: '50',
            bgColor: '#fff',
            logoSize: 0.25,
            borderSize: 0
          }
        });
      }, 5);
    },
    createQrCodeForSmallWidth() {
      setTimeout(() => {
        let qr_canvas = document.createElement('canvas');
        qr_canvas.style.cursor = 'pointer';
        document.getElementById('qr_for_small_width').appendChild(qr_canvas);
        QrCodeWithLogo.toCanvas({
          canvas: qr_canvas,
          content: this.ps_link,
          width: 200,
          height: 200,
          logo: {
            src: "./favicon_new_dark.png",
            borderRadius: '50',
            bgColor: '#fff',
            logoSize: 0.25,
            borderSize: 0
          }
        })
      }, 5);
    }
  },
  computed: {
    ps_link_text() {
      return 'PayStar.ir/@' + this.current_user.username;
    },
    ps_link()
    {
      return 'https://paystar.ir/@' + this.current_user.username;
    },
    ...mapGetters('user', [
      'current_user'
    ]),
    user_full_name()
    {
      return this.current_user.first_name + ' ' + this.current_user.last_name;
    }
  },
  mounted()
  {
    this.createQrCode();
    this.createQrCodeForSmallWidth();
  }
}
</script>

<style scoped>

</style>